import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GemCard = ({ gem, index }) => {
  const rarityColors = {
    common: 'border-accent/50 shadow-glow-green-sm',
    rare: 'border-primary/50 shadow-glow-cyan-sm',
    epic: 'border-secondary/50 shadow-glow-magenta-sm',
    legendary: 'border-warning/50 shadow-[0_0_10px_#FFAA00]'
  };

  const rarityIcons = {
    common: 'Gem',
    rare: 'Diamond',
    epic: 'Crown',
    legendary: 'Sparkles'
  };

  return (
    <div 
      className={`gem-card bg-card border-2 ${rarityColors?.[gem?.rarity]} rounded-sm p-4 md:p-6 transition-all duration-base hover:scale-105 hover:shadow-glow-cyan-md`}
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="relative w-full aspect-square mb-3 md:mb-4 bg-background rounded-sm border border-primary/30 overflow-hidden flex items-center justify-center">
        <Image
          src={gem?.image}
          alt={gem?.imageAlt}
          className="w-full h-full object-contain p-2 md:p-3"
        />
        <div className={`absolute top-2 right-2 w-6 h-6 md:w-8 md:h-8 rounded-sm bg-${gem?.rarity === 'common' ? 'accent' : gem?.rarity === 'rare' ? 'primary' : gem?.rarity === 'epic' ? 'secondary' : 'warning'}/20 border border-${gem?.rarity === 'common' ? 'accent' : gem?.rarity === 'rare' ? 'primary' : gem?.rarity === 'epic' ? 'secondary' : 'warning'} flex items-center justify-center`}>
          <Icon 
            name={rarityIcons?.[gem?.rarity]} 
            size={14} 
            color={`var(--color-${gem?.rarity === 'common' ? 'accent' : gem?.rarity === 'rare' ? 'primary' : gem?.rarity === 'epic' ? 'secondary' : 'warning'})`}
          />
        </div>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <h3 className="font-heading font-semibold text-sm md:text-base text-foreground line-clamp-1">
            {gem?.name}
          </h3>
          <span className={`text-xs md:text-sm font-caption uppercase tracking-wider ${
            gem?.rarity === 'common' ? 'text-accent' :
            gem?.rarity === 'rare' ? 'text-primary' :
            gem?.rarity === 'epic'? 'text-secondary' : 'text-warning'
          }`}>
            {gem?.rarity}
          </span>
        </div>

        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Brain" size={14} />
          <span className="font-caption line-clamp-1">{gem?.aiMood}</span>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-primary/20">
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Icon name="Trophy" size={12} />
            <span className="font-data">Tier {gem?.difficultyTier}</span>
          </div>
          <span className="text-xs font-data text-muted-foreground">
            {gem?.dateAcquired}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GemCard;